<script>
import { authMethods, notificationMethods }from "@/state/helpers";
import { required, email } from "vuelidate/lib/validators";
import { errorMessages } from "@/helpers/validations/errorMessages";

export default {
  data() {
    return {
      email: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      loading: false,
      errorMsg: null,
      errorMessages,
    };
  },
  validations: {
    email: { required, email }
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    // Try to register the user in with the email, fullname
    // and password they provided.
    async tryToReset() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.loading = true;
        this.tryingToReset = true;
        // Reset the authError if it existed.
        this.errorMsg = null;
        try {
            await this.forgotPassword({
              email: this.email
            });
            this.loading = false;
            this.tryingToReset = false;
            this.isResetError = false;
            this.success("Hemos mandado un enlace a tu email para restaurar tu contraseña..");
            this.$router.push({ name: "login" });
        }
        catch (error) {
            this.loading = false;            
            let errorMsg = `<div>${error?.response?.data?.extra[0]?.errors?.email[0]}</div>`;
            this.errorMsg = errorMsg;
        }
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div class=" mb-3">
                          <a href="/" class="logo">
                            <img src="@/assets/images/banner-cabecera.jpg" height="20" alt="logo" />
                          </a>
                        </div>
                        <div>
                          <a href="/" class="logo">
                            <img src="@/assets/images/logo-iDEAFP.png" height="60" alt="logo" />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">Resturar contraseña</h4>
                        <p class="text-muted">Restaurar contraseña para iDEAFP</p>
                      </div>

                      <div class="p-2 mt-5">
                        <b-alert variant="danger" class="mt-3" v-if="errorMsg" show>
                            <div v-html="errorMsg"></div>
                        </b-alert>

                        <!-- <b-alert
                          v-model="isResetError"
                          class="mb-4"
                          variant="danger"
                          dismissible
                        >{{error}}</b-alert> -->

                        <form class="form-horizontal" @submit.prevent="tryToReset">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="useremail">Email</label>
                            <input v-model="email" type="email" class="form-control" id="useremail" placeholder="Introduce email" :class="{ 'is-invalid': submitted && $v.email.$error }"/>
                            <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                              <span v-if="!$v.email.required">{{ errorMessages.required }}</span>
                              <span v-if="!$v.email.email">{{ errorMessages.email }}</span>
                            </div>
                          </div>
                          <div class="mt-4 text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                              :disabled="loading"
                            ><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                            Restaurar contraseña</button>
                          </div>
                        </form>
                      </div>

                      <div class="mt-5 text-center">
                        <p>
                          <router-link
                            tag="a"
                            to="/login"
                            class="font-weight-medium text-primary"
                          >Log in</router-link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>